import Swiper from 'swiper';
import {Pagination, Autoplay} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

//console.log('Hero Slider - plik view.js załadowany');

(function () {
    function initHeroSwiper() {
        //console.log('Inicjalizacja Swipera uruchomiona');

        const heroSliders = document.querySelectorAll('.hero-slider-container');
        //console.log('Znaleziono sliderów:', heroSliders.length);

        if (heroSliders.length > 0) {
            heroSliders.forEach((slider, index) => {
                //console.log(`Inicjalizacja slidera ${index + 1}`);

                try {
                    if (typeof Swiper !== 'function') {
                        console.error('Swiper nie jest prawidłowo zaimportowany!');
                        return;
                    }

                    const slidesWrapper = slider.querySelector('.swiper-wrapper');
                    const slides = slidesWrapper ? slidesWrapper.querySelectorAll('.swiper-slide') : [];

                    if (slides.length === 0) {
                        console.warn(`Slider ${index + 1} nie ma slajdów!`);
                        return;
                    }

                    const navContainer = slider.querySelector('.hero-slider-navigation .hero-slider--title');
                    const navItems = navContainer ? navContainer.querySelectorAll('.hero-slider--title__text') : [];

                    // Inicjalizacja Swipera
                    const swiper = new Swiper(slider, {
                        modules: [Pagination, Autoplay],
                        slidesPerView: 1,
                        spaceBetween: 0,
                        pagination: {
                            el: slider.querySelector('.swiper-pagination'),
                            clickable: true
                        },
                        autoplay: {
                            delay: 3000,
                            disableOnInteraction: false
                        },
                        loop: true,
                        watchSlidesProgress: true
                    });

                    // Obsługa nawigacji
                    if (navItems.length > 0) {
                        // Ustaw pierwszy element jako aktywny
                        navItems[0].classList.add('active');

                        navItems.forEach((navItem, idx) => {
                            // Dodaj style dla interakcji
                            navItem.style.cursor = 'pointer';
                            navItem.style.userSelect = 'none';

                            // Event listener dla kliknięcia
                            navItem.addEventListener('click', function (e) {
                                e.preventDefault();
                                e.stopPropagation();

                                console.log(`Kliknięto nawigację ${idx}`);

                                // Usuń klasę active z wszystkich
                                navItems.forEach(item => item.classList.remove('active'));

                                // Dodaj do klikniętego
                                navItem.classList.add('active');

                                // Przejdź do slajdu - używamy slideToLoop dla poprawnej obsługi loop
                                swiper.slideToLoop(idx);
                            });

                            // Event listener dla klawiatury (accessibility)
                            navItem.addEventListener('keydown', function (e) {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    navItem.click();
                                }
                            });
                        });

                        // Event listener dla zmian slajdów
                        swiper.on('slideChange', function () {
                            const realIndex = swiper.realIndex;

                            navItems.forEach((item, i) => {
                                if (i === realIndex) {
                                    item.classList.add('active');
                                } else {
                                    item.classList.remove('active');
                                }
                            });
                        });

                        // Dodatkowy event dla końca transycji
                        swiper.on('slideChangeTransitionEnd', function () {
                            const realIndex = swiper.realIndex;

                            navItems.forEach((item, i) => {
                                if (i === realIndex) {
                                    item.classList.add('active');
                                } else {
                                    item.classList.remove('active');
                                }
                            });
                        });
                    }

                    // console.log(`Slider ${index + 1} zainicjalizowany pomyślnie`);

                } catch (e) {
                    console.error(`Błąd inicjalizacji Swipera dla slidera ${index + 1}:`, e);
                }
            });

            // Funkcja responsive images
            function updateSliderImages() {
                const width = window.innerWidth;

                heroSliders.forEach((slider) => {
                    const slides = slider.querySelectorAll('.swiper-slide');
                    slides.forEach((slide) => {
                        const desktopImage = slide.querySelector('.desktop-image');
                        const mobileImage = slide.querySelector('.mobile-image');

                        if (!desktopImage && !mobileImage) return;

                        if (width < 960) {
                            if (mobileImage) mobileImage.style.display = 'block';
                            if (desktopImage) desktopImage.style.display = 'none';
                        } else {
                            if (desktopImage) desktopImage.style.display = 'block';
                            if (mobileImage) mobileImage.style.display = 'none';
                        }
                    });
                });
            }

            updateSliderImages();
            window.addEventListener('resize', updateSliderImages);
        } else {
            console.warn('Nie znaleziono żadnego slidera na stronie');
        }
    }

    // Inicjalizacja
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(initHeroSwiper, 100);
        });
    } else {
        setTimeout(initHeroSwiper, 100);
    }

    // Backup inicjalizacja
    setTimeout(initHeroSwiper, 1000);
})();